export const createStyleManager = (id: string) => () => {
  const ele = document.createElement('style-manager') as HTMLDivElement;
  ele.setAttribute('id', id);
  document.head.appendChild(ele);

  return () => {
    const ele = document.getElementById(id);
    document.head.removeChild(ele);
  };
};
